import { useEffect, useState } from "react";
import { listPublicServices, listPublicTestimonials, readPublicCache } from "@/lib/data";

function usePublicContent(key, loader) {
  const [data, setData] = useState(() => readPublicCache(key));
  useEffect(() => {
    let mounted = true;
    loader().then((d) => mounted && setData(d));
    return () => { mounted = false; };
  }, [loader]);
  return data;
}

export const useServices = () => usePublicContent("services", listPublicServices);
export const useTestimonials = () => usePublicContent("testimonials", listPublicTestimonials);
